// Application Configuration Constants
// This file reads from environment variables (set in app.yaml) if available,
// otherwise falls back to default values for local development

export const CONFIG = {
  // API Base URLs
  // Uses environment variable from app.yaml if set, otherwise uses default
  API_BASE_DEV: process.env.REACT_APP_API_BASE_DEV || "https://ludo-web-dot-leaderboard-dot-ludo-112c9.uc.r.appspot.com",
  API_BASE_LEAGUE: process.env.REACT_APP_API_BASE_League || "https://ludo-web-dot-league-dot-ludo-112c9.uc.r.appspot.com",
  API_BASE_LOGIN: process.env.REACT_APP_API_BASE_login || "https://ludo-web-dot-config-server-dot-ludo-112c9.uc.r.appspot.com/",
  API_BASE_UPDATES: process.env.REACT_APP_API_BASE_UPDATES || "https://dash.ludo.ooo:8443/bsw-web",
  API_BASE_LEADERBOARD_LEAGUE: process.env.REACT_APP_API_BASE_LEADERBOARD_LEAGUE || "https://league.ludo.ooo/website-leaderboard",
  
  // Mission Leaderboard URLs
  API_BASE_MISSION_COUNTRY_DATA: process.env.REACT_APP_API_BASE_MISSION_COUNTRY_DATA || "https://ldb.ludo.ooo/leaderboard?acu=IN",
  API_BASE_MISSION_GLOBAL_DATA: process.env.REACT_APP_API_BASE_MISSION_GLOBAL_DATA || "https://ldb.ludo.ooo/leaderboard",
  
  // Application Settings
  BASE_FOLDER: process.env.REACT_APP_BASE_FOLDER || "bsw-game",
  PUBLIC_URL: process.env.PUBLIC_URL || "",
  IMD_AMOUNT: process.env.REACT_APP_IMD_AMOUNT || "1.00",

  // Collectibles under app base path
  COLLECTIBLES_BASE_PATH: "/bsw-game/Collectibles",

  /** Build Collectibles image URL. e.g. getCollectiblesImagePath("regular", "dishes", "Croissant.png") → "/bsw-game/Collectibles/regular/dishes/Croissant.png" */
  getCollectiblesImagePath: (category, subcategory, filename) =>
    `/bsw-game/Collectibles/${category}/${subcategory}/${filename}`,

  // Google Analytics 4
  GA_MEASUREMENT_ID: "G-HZ8QH0Q49P",
  GA_PROPERTY_ID: "524681345",
};

export default CONFIG;
